module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-outside-sg/desktop-e8b2092af4826558b7dbcd009306f91b.png";